import { render, staticRenderFns } from "./SugerenciasList.vue?vue&type=template&id=1026bb79&"
import script from "./SugerenciasList.vue?vue&type=script&lang=js&"
export * from "./SugerenciasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports